import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Marketplace\DisableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/DisableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/disable'
*/
const DisableMarketplaceModuleController = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DisableMarketplaceModuleController.url(args, options),
    method: 'get',
})

DisableMarketplaceModuleController.definition = {
    methods: ["get","head"],
    url: '/api/marketplace/module/{moduleId}/disable',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Marketplace\DisableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/DisableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/disable'
*/
DisableMarketplaceModuleController.url = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { moduleId: args }
    }

    if (Array.isArray(args)) {
        args = {
            moduleId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        moduleId: args.moduleId,
    }

    return DisableMarketplaceModuleController.definition.url
            .replace('{moduleId}', parsedArgs.moduleId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Marketplace\DisableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/DisableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/disable'
*/
DisableMarketplaceModuleController.get = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DisableMarketplaceModuleController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Marketplace\DisableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/DisableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/disable'
*/
DisableMarketplaceModuleController.head = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: DisableMarketplaceModuleController.url(args, options),
    method: 'head',
})

export default DisableMarketplaceModuleController